import * as moment from 'moment-timezone';
import { Subject } from 'rxjs';
import { ElementRef, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService, TeamMembershipStatus, } from 'app/shared/services/challenge.service';
import { UserService } from 'app/shared/services/user.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
var ChallengeStatus;
(function (ChallengeStatus) {
    ChallengeStatus["RUNNING"] = "running";
    ChallengeStatus["FUTURE"] = "future";
})(ChallengeStatus || (ChallengeStatus = {}));
var BoxComponent = (function () {
    function BoxComponent(translate, router, userService, challengeService, snackBar) {
        this.translate = translate;
        this.router = router;
        this.userService = userService;
        this.challengeService = challengeService;
        this.snackBar = snackBar;
        this.hideButtons = false;
        // User Interaction by clicking on element
        this.onSelect = new EventEmitter();
        this.onEdit = new EventEmitter();
        this.onRemove = new EventEmitter();
        this.up = 'up';
        this.mp = 'mp';
        this.ex = 'ex';
        this.new = 'new';
        this.play = 'play';
        this.add = 'add';
        this.remove = 'remove';
        this.showDelete = false;
        this.showLeaveTeamDialog = false;
        this.ngUnsubscribe = new Subject();
        // Reference to ChallengeStatus to be able to use it in template
        this.ChallengeStatus = ChallengeStatus;
        // Reference to TeamMembershipStatus to be able to use it in template
        this.TeamMembershipStatus = TeamMembershipStatus;
    }
    /**
     * Subscribe to current user to be able to find out his team status
     */
    BoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.currentUser = user;
        });
        if (this.boxType === 'challenge') {
            this.challengeService.displayedChallenge.takeUntil(this.ngUnsubscribe).subscribe(function (challenge) {
                _this.challenge = challenge;
                _this.setChallengeTimeFrame();
            });
            this.challengeService.team.takeUntil(this.ngUnsubscribe).subscribe(function (team) {
                _this.team = team;
            });
            this.challengeService.teamUser.takeUntil(this.ngUnsubscribe).subscribe(function (teamUser) {
                _this.teamUser = teamUser;
            });
        }
        var videoElement = this.myVideo.nativeElement;
        videoElement.addEventListener('loadedmetadata', function () {
            _this.videoDuration = videoElement.duration;
        });
        videoElement.load();
    };
    BoxComponent.prototype.clickOnActionbutton = function () {
        this.onSelect.emit();
    };
    BoxComponent.prototype.editBox = function () {
        this.onEdit.emit();
    };
    BoxComponent.prototype.removeAskBox = function (event) {
        this.showDelete = true;
    };
    BoxComponent.prototype.closeAskRemove = function () {
        this.showDelete = false;
    };
    BoxComponent.prototype.removeBox = function (e) {
        e.stopPropagation();
        this.onRemove.emit();
    };
    /**
     * Display or hide leave team dialog (only for team members who are not the founder)
     */
    BoxComponent.prototype.showLeaveTeam = function (show) {
        this.showLeaveTeamDialog = show;
    };
    BoxComponent.prototype.confirmLeaveTeam = function () {
        var _this = this;
        this.challengeService.removeUserFromTeam(this.team.challengeID, this.team._id, this.currentUser._id).catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                _this.challengeService.reloadTeams();
            });
        });
    };
    BoxComponent.prototype.declineInvitation = function () {
        var _this = this;
        this.challengeService.declineInvitation(this.team.challengeID, this.team._id, this.currentUser.email).catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                _this.challengeService.reloadTeams();
            });
        });
    };
    BoxComponent.prototype.acceptInvitation = function () {
        var _this = this;
        this.challengeService
            .acceptInvitation(this.team.challengeID, this.team._id, this.currentUser._id)
            .catch(function (error) {
            var errorObject = error.body.error.error;
            if (errorObject.startsWith('maximum_challenge_members')) {
                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else {
                _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                    _this.challengeService.reloadTeams();
                });
            }
        });
    };
    BoxComponent.prototype.cancelApplication = function () {
        var _this = this;
        this.challengeService.cancelApplication(this.team.challengeID, this.team._id, this.currentUser._id).catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                _this.challengeService.reloadTeams();
            });
        });
    };
    /**
     * Decides whether challenge is in past,present in future
     * and which number for remaining or passed days should be shown
     */
    BoxComponent.prototype.setChallengeTimeFrame = function () {
        if (!this.challenge) {
            return;
        }
        if (moment(this.challenge.start).isAfter(moment())) {
            this.challengeStatus = ChallengeStatus.FUTURE;
            this.displayedTimeframe = this.getDisplayedTimeframe(moment(this.challenge.start));
        }
        else if (moment(this.challenge.end).isAfter(moment())) {
            this.challengeStatus = ChallengeStatus.RUNNING;
            this.displayedTimeframe = this.getDisplayedTimeframe(moment(this.challenge.end));
        }
        else {
            this.challengeStatus = null;
            this.displayedTimeframe = null;
        }
    };
    /**
     * Decides based on language and time difference between date and now, which time is displayed
     */
    BoxComponent.prototype.getDisplayedTimeframe = function (date) {
        var language = this.currentUser.language;
        // For calculating date difference in localized user time, compare dates from start of day
        var startOfToday = moment().tz(this.currentUser.timeZone).startOf('day');
        var startOfReferencedDay = moment(date).tz(this.currentUser.timeZone).startOf('day');
        var dateDifference = Math.abs(startOfReferencedDay.diff(startOfToday, 'days'));
        if (dateDifference >= 2) {
            return language === 'de' ? 'In ' + dateDifference + ' Tagen' : 'in ' + dateDifference + ' days';
        }
        else {
            return date.tz(this.currentUser.timeZone).calendar(null, language === 'de'
                ? { sameDay: '[Heute um] HH:mm [Uhr]', nextDay: '[Morgen um] HH:mm [Uhr]' }
                : {
                    sameDay: '[Today at] LT',
                    nextDay: '[Tomorrow at] LT',
                });
        }
    };
    BoxComponent.prototype.navigateSelectTeam = function () {
        this.router.navigate(['challenge', this.challenge._id, 'team']).then();
    };
    BoxComponent.prototype.openChallengeTutorial = function () {
        this.router.navigate(['challengeTutorial']).then();
    };
    BoxComponent.prototype.navigateTeamDetails = function () {
        this.router.navigate(['stats']).then();
    };
    /**
     * On destroy cancel active subscriptions
     */
    BoxComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return BoxComponent;
}());
export { BoxComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/box/box.component.ts.pre-build-optimizer.js